import { configureStore } from '@reduxjs/toolkit';

import badgeReducer from './slices/badge-slice';

export const makeStore = () =>
  configureStore({
    reducer: {
      badge: badgeReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

export const store = makeStore();
